<template lang="pug">
  div(v-if="links.length > 0")
    template(v-for="l in pageItems")
      application-list-tile(
        :id="l.guid"
        :topRight="getSource(l)"
        :icon="l.loanPlanLender && companyLogo(fplToStressfree(l.loanPlanLender))"
        :topLeftSubtext="getSubtext(l)"
        :latestActivity="latestActivity(l)"
        :activity="getActivity(l)"
        :ctas="ctas(l)"
        class="pt-1"
      )
    v-pagination(
      :length="pages"
      v-model="page"
      @input="paginate($event)"
    )
  div(v-else)
    div
      img(
        :src="noDataImg"
        height="350"
      )
      p(class="pb-4 display-1") You haven't sent any Easy Links yet
    span(class="title")
      p(class="mb-4 grey--text text--darken-1")
        | You can send an
        router-link(tag="a" to="/credit-application/plans" class="wf-link ml-1 mr-1") Easy Link
        | to your customers
</template>

<script>
  import ApplicationListTile from 'Components/ApplicationListTile'
  import Lenders from 'Mixins/Lenders'
  import _orderBy from 'lodash/orderBy'
  import moment from 'moment'

  export default {
    name: 'leads-list',
    components: {
      ApplicationListTile,
    },
    mixins: [Lenders],
    data() {
      return {
        greenskyPlans: [],
        noDataImg: require('Assets/empty-desert.png'),
        page: 1,
        pageSize: 6,
      }
    },
    computed: {
      links() {
        return _orderBy(
          this.$store.state.user.easyLinkLeads,
          ['createdDatetime'],
          ['desc']
        )
      },
      pages() {
        return Math.ceil(this.links.length / this.pageSize)
      },
      pageItems() {
        return this.links.slice(
          (this.page-1) * this.pageSize,
          this.page * this.pageSize
        )
      },
    },
    methods: {
      fplToStressfree(value){
        return value === 'fpl' ? 'stressfree' : value
      },
      ctas(l) {
        let list = []

        if (l.hasOwnProperty('phone') && l.phone) {
          list.push({
            key: 'phone',
            icon: 'phone',
            type: 'link',
            label: l.phone,
            href: `tel:${l.phone}`,
          })
        } else if (l.hasOwnProperty('email') && l.email) {
          list.push({
            key: 'email',
            type: 'link',
            icon: 'mail_outline',
            label: l.email,
            href: `mailto:${l.email}`,
          })
        }

        return list
      },
      getActivity(l) {
        return _orderBy(
          l.activity,
          ['at'],
          ['desc']
        ).map(a => {
          const _date = moment(a.at).format('dddd, MMM DD')
          const time = moment(a.at).format('h:mm a')
          const datetime = `${_date} at ${time}`
          const activity = this.parseActivity(l, a)

          return [datetime, activity]
        }, [])
      },
      getSource(l) {
        return (l.source === 'oncallair')
          ? ['OnCall Air']
          : (l.source === 'comfortbutton')
            ? ['Comfort Button']
            : [l.source]
      },
      latestActivity(l) {
        return `${l.dealerName} sent an offer for ${l.loanAmount}`
      },
      paginate(newPage) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      },
      parseActivity(l, a) {
        let sent = `${l.dealerName || l.companyName} <span class="green--text">sent</span> an offer`
        if (l.amount) sent += ` for ${l.loanAmount}`
        return {
          sent,
          open: `Customer <span class="green--text">opened</span>`,
          submit: `Customer <span class="green--text">submitted</span>`,
        }[a.type]
      },
      getSubtext(lead) {
        const subtext = []

        if (lead.loanPlanLender === 'greensky') {
          const plan = this.greenskyPlans.find(p => p.id === Number(lead.loanPlanId))

          if (plan) {
            subtext.push(`Plan ${plan.planNumber}: ${plan.planLength} Months`)
            subtext.push(plan.interestRateMessage)
          }
        }

        return subtext
      },
    },
    mounted() {
      this.$store.dispatch('getAllGreenskyPlans').then(plans => {
        this.greenskyPlans = plans
      })
    },
  }
</script>
